<template>
	<b-modal
		id="modal-reinicioEvaluacion"
		@show="resetModal"
		@ok="handleEnvio"
	>
		<template v-slot:modal-title>
       <div align="center">
        <h5 class="mt-0">¿Estas seguró que deseas reiniciar la nota?</h5>
      </div>
		</template>
		<b-form-group>
      <b-container class="bv-example-row">
        <b-row>
          <b-col cols="2"> 
            <b-avatar v-if="activeAlumno" variant="primary" :text="abreviacionNombre(activeAlumno)" style="margin-top: 20%;width: 3.0em;height: 3.0em;"></b-avatar>
          </b-col>
          <b-col cols="10">
            <span>Nota Examen: {{activeAlumno.notaAlumno}}</span>
            <br>
            <span>{{activeAlumno.nombreAlumno}}</span>
            <br>
             <span >{{activeAlumno.numeroDocumento}}</span>
          </b-col>
        </b-row>
      </b-container>
      <small>
				Recuerda que al reiniciar la nota del alumno se eliminará tambien el promedio y este cambio será irreversible.
			</small>
		</b-form-group>
         	<template v-slot:modal-footer="{ ok, cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button @click="cancel()" ref="cerrarModalReinicio"> Cancelar </b-button>
        <b-button variant="primary" @click="ok()">
          Aceptar
        </b-button>
		  </template>
       <toastComponent ref="toastComponent" />
	</b-modal>
</template>
<script>
import {mapState, mapActions} from 'vuex'
import toastComponent from "@/components/toastComponent.vue";
import $ from "jquery";
export default {
  components: {
      toastComponent
	},
  data: () => ({}),
  computed:{
    ...mapState('alumno',['activeAlumno']),
   
  },
  methods:{
     ...mapActions('alumno',['updateNotaAlumno']),
    abreviacionNombre(alummno){
      let abr = "";
      alummno.nombreAlumno.split(" ").map((p)=> abr = abr + p.substring(0, 1));
      return abr;
    },
    handleEnvio(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.resetNotaAlumno();
    },
    async resetNotaAlumno(){
      const form = this.activeAlumno;
      
      const {data} = await this.axios.post('api/resetNotaAlumno',form);
      if(data.msg === 'exito'){
        let arrayToast = {
          msg: "Se ha actualizado el estado con exito.",
          title: "Estado Nota",
          variant: "success",
        };
        this.$refs.toastComponent.makeToast(arrayToast);

        var table = $('#tablaEvaluaciones').DataTable();
			  table.ajax.reload();
        // this.$refs.cerrarModalReinicio.click();
        // this.updateNotaAlumno(this.activeAlumno);
      }  

    },
    resetModal() {},
  }
}
</script>